export const LOAD_APPLIED_LEAVES = "LOAD_APPLIED_LEAVES";
export const LOAD_PENDING_LEAVES = "LOAD_PENDING_LEAVES";
export const DELETE_LEAVE = "DELETE_LEAVE"